var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptopMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 64C112 55.178 119.178 48 128 48H448C456.822 48 464 55.178 464 64V96H512V64C512 28.654 483.348 0 448 0H128C92.654 0 64 28.654 64 64V320H16C7.164 320 0 327.162 0 336C0 362.51 21.49 384 48 384H352V320H112V64ZM576 128H448C412.654 128 384 156.654 384 192V448C384 483.346 412.654 512 448 512H576C611.348 512 640 483.346 640 448V192C640 156.654 611.348 128 576 128ZM592 448C592 456.822 584.822 464 576 464H448C439.178 464 432 456.822 432 448V192C432 183.178 439.178 176 448 176H576C584.822 176 592 183.178 592 192V448Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopMobile);
export default __webpack_public_path__ + "static/media/laptop-mobile.47f15a1990c1cb2a1c4dcfeca3a1d86a.svg";
export { ForwardRef as ReactComponent };